import api from '../tools/api';

export const codeCheck = code => api.request(
    'checkpromo',
    {
        content: code
    }
);

export default {
    codeCheck
};
